import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { compareWithJSON } from '@/utils/helper'
import { useMyApprovableTotal } from '@/utils/queries/approval'
import { qtyToCurrency } from '@/utils/formatting'
import { approvalIsEnabledSelector } from '@/redux/selectors'
import styles from './style.module.scss'

const ApprovalInfo = ({ isMenuCollapsed = false }) => {
  const approvalIsEnabled = useSelector(approvalIsEnabledSelector)

  const { data } = useMyApprovableTotal({ enabled: approvalIsEnabled })
  const total = data?.data || 0
  if (total <= 0) {
    return null
  }

  return (
    <div className={isMenuCollapsed ? styles.badgeCollapsed : styles.badge}>
      {qtyToCurrency(total)}
    </div>
  )
}

export default memo(ApprovalInfo, compareWithJSON)
